/* eslint-disable @typescript-eslint/no-explicit-any */
import { FormikProps } from 'formik';
import { useAppSelector } from '@Hooks/index';
import {
  getAttendanceTypesDict,
  getCompanyOptions,
  getITAccessories,
  getITReqItemsDictSelector,
  getOrganizationsDict,
  getOverseasSponsorsDictSelector,
  getWorkLocationTypes,
  getDepartmentProjectsList,
} from '@Store/selectors/dictionarySelector';

import { getSimpleKeyTags } from './utils/getSimpleKeyTags';
import { getArrKeyTags } from './utils/getArrKeyTags';

import styles from './tags.module.css';

interface TagsProps {
  formik?: FormikProps<any>;
  showTags?: boolean;
}

const Tags: React.FC<TagsProps> = ({ formik, showTags = false }) => {
  const attendanceTypes = useAppSelector(getAttendanceTypesDict);
  const companies = useAppSelector(getCompanyOptions);
  const workLocations = useAppSelector(getWorkLocationTypes);
  const overseasSponsors = useAppSelector(getOverseasSponsorsDictSelector);
  const accessories = useAppSelector(getITAccessories);
  const itReqTypes = useAppSelector(getITReqItemsDictSelector);
  const organizations = useAppSelector(getOrganizationsDict);
  const departmentProjectsList = useAppSelector(getDepartmentProjectsList);

  if (!showTags || !formik?.values) {
    return null;
  }

  const { values } = formik;
  const keys = Object.keys(values);

  const [arrKeys, simpleKeys] = keys.reduce(
    (acc, key) => {
      const value = values[key];

      if (Array.isArray(value) && !!value.length) {
        acc[0].push(key);
      } else if (
        !Array.isArray(value) &&
        value !== null &&
        value !== '' &&
        value !== undefined
      ) {
        acc[1].push(key);
      }

      return acc;
    },
    [[], []] as [string[], string[]]
  );

  // Transform department/project list to the format expected by getLabel
  const departments = departmentProjectsList
    .filter((item) => item.wlId === 1) // Filter for departments (wlId = 1)
    .map((item) => ({ key: item.projDeptID, value: item.projDeptName }));

  const projects = departmentProjectsList
    .filter((item) => item.wlId === 2) // Filter for projects (wlId = 2)
    .map((item) => ({ key: item.projDeptID, value: item.projDeptName }));

  const simpleKeyTags = getSimpleKeyTags(
    simpleKeys,
    formik,
    attendanceTypes,
    companies,
    workLocations,
    overseasSponsors,
    accessories,
    itReqTypes,
    organizations,
    departments,
    projects,
    styles
  );
  const arrKeyTags = getArrKeyTags(arrKeys, formik, styles);

  const tags = [...simpleKeyTags, ...arrKeyTags];

  return tags.length ? <div className={styles.wrapper}>{tags}</div> : null;
};

export default Tags;
